module.exports = __webpack_public_path__ + "img/home_huiyuanzhongxin.8a5c9bdc.jpg";